export default function scrollToController() {
  // Use event delegation on document (or body)
  document.addEventListener('click', function (event) {
    // Check if the clicked element is (or is inside) an <a> with href starting with "#"
    const link = event.target.closest('a[href^="#"]');

    // If no matching link was found, or if .closest() found nothing, do nothing
    if (!link) return;

    // Prevent the default jump
    event.preventDefault();

    // Retrieve the target element from the href attribute
    const targetId = link.getAttribute('href');

    if (targetId.length <= 1) {
      return;
    }

    const targetElement = document.querySelector(targetId);

    // If the target element exists, smoothly scroll to it
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth',
      });
    }
  });
}
